import * as React from 'react';
import { ArticleParagraph3 } from '@cian/ui-kit';

import styles from './PersonalAgreement.css';

import { InlineLink } from '../../InlineLink';

interface IPersonalAgreementProps {
  policyUrl: string;
  personalDataAgreement: string;
}

export const PersonalAgreement: React.FC<IPersonalAgreementProps> = ({ policyUrl, personalDataAgreement }) => {
  return (
    <div className={styles['container']}>
      <ArticleParagraph3 color="gray60_100">
        Нажимая кнопку, я соглашаюсь на{' '}
        <InlineLink href={personalDataAgreement} target="_blank" rel="noopener noreferrer">
          обработку персональных данных
        </InlineLink>{' '}
        в соответствии с{' '}
        <InlineLink href={policyUrl} target="_blank" rel="noopener noreferrer">
          политикой конфиденциальности
        </InlineLink>
      </ArticleParagraph3>
    </div>
  );
};
